const billing = {
  billing: 'Facturation',
  billingChargesSoFar: 'Frais à ce jour',
  billingChargesSoFarDetail: 'Exécutions de connecteurs déjà facturées ce mois-ci, à 0,01 $ chacune.',
  billingMonthEstimate: 'Estimation du mois',
  billingMonthEstimateDetail: 'Une exécution par connecteur actif chaque jour, à 0,01 $. Les exécutions déjà terminées ce mois-ci sont incluses.',
  creditCardCvc: 'CVC',
  creditCardExpiration: 'Date d\'expiration',
  creditCardName: 'Nom du détenteur',
  creditCardNumber: 'Numéro de carte de crédit',
  pay: 'Payer',
  payments: 'Paiements',
  setUpBilling: 'Configurer la facturation',
};

export default billing;
